import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill="#616061" fillRule="evenodd" d="M15 1H1v14h14zm-2.293 4.708-1.414-1.415L6.5 9.086 4.707 7.293 3.293 8.708 6.5 11.915z" clipRule="evenodd" />
  </svg>
);
export default SvgCheckSquare;
